import React from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { If } from 'utils';
import Note from './Note';
import { useNotes } from 'utils/hooks';

export default function List() {
  const { notes, onDelete } = useNotes();

  const renderNotes = notes.map((data, index) => {
    const id = _get(data, 'id', index);
    return <Note key={id} data={data} onDelete={() => onDelete(id, index)} />;
  });

  return (
    <If test={notes.length > 0}>
      <ul className={styles.container}>{renderNotes}</ul>
    </If>
  );
}
